import React, {useState, useEffect} from 'react';
import { makeStyles, Divider, Typography, Button, TextField, Select } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import clsx from 'clsx';
import { addEditDrawerWidth} from '../../Config/constants';
import CloseIcon from '@material-ui/icons/Close';
import {crudService} from '../../Services/crudService';
import { toast } from 'react-toastify';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

export default function CrudAddEditDrawer(props) {
    const classes = useStyles();
    const [addeditObject, setAddeditObject] = useState({});

    useEffect(() => {
        if(props.editId !== null){
            let editObject = props.rows.find(r => r.id === props.editId);
            if(editObject !== addeditObject) {
                setAddeditObject(editObject);
            }
        } else {
            if ( JSON.stringify(addeditObject) !== JSON.stringify({}) ){
                setAddeditObject({});
            } 
        }
    }, [props.editId, props.rows, addeditObject]);

    const fieldChanged = (column, value) => {
        let obj = addeditObject;
        obj[column] = value;
        setAddeditObject(obj);
    }

    const handleAddEdit = (row, title) => {
        if(title === "Edit") {
            crudService.editTableRow(props.crud.schemeName, props.crud.api, props.user.userToken, row).then(() => props.setReload(true)).catch((error) => {
                toast.error(error, {
                  position: toast.POSITION.TOP_CENTER
                });
              });
        }

        if(title === "Add") {
            crudService.addTableRow(props.crud.schemeName, props.crud.api, props.user.userToken, row).then(() => props.setReload(true)).catch((error) => {
                toast.error(error, {
                  position: toast.POSITION.TOP_CENTER
                });
              });
        }

        props.setReload(true);
        props.openDrawer("", false, null)
    };

    const getForeignKeyRecordValue = (record) => {
        if(record["name"] !== undefined){
            return record["name"] 
        }

        if(record["descriptioon"] !== undefined){
            return record["name"] 
        }

        if(record["code"] !== undefined){
            return record["name"] 
        }

        if(record["status"] !== undefined){
            return record["name"] 
        }
        return "no name info"
    }

    const GetEditorForDataType = (column) => {


        let isTooMuchInfo = false;
        if (props.foreignObjects[column.name] !== undefined) {
            if (props.foreignObjects[column.name].length >= 30) {
                isTooMuchInfo = true;
            }
        }

        if(column.isPrimaryKey === "True"){
            return <React.Fragment key={column.name}></React.Fragment>
        }

        if(column.isForeignKey === "True" && !isTooMuchInfo){
            return <React.Fragment key={column.name}>
                        <InputLabel>{column.name}</InputLabel>
                        <Select fullWidth value={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value)}>
                            {(props.foreignObjects[column.name] !== undefined && props.foreignObjects[column.name] !== null) ? props.foreignObjects[column.name].map((record, index) => (
                                <MenuItem key={record.id} value={record.id}>{getForeignKeyRecordValue(record)}</MenuItem>
                            )) : <MenuItem value={null}>Empty</MenuItem>}
                        </Select>
                    </React.Fragment>
        }

        switch(column.dataType) {
            case 'bit':
                return <FormControlLabel
                            key={column.name}
                            value="end"
                            control={<Checkbox color="primary" defaultChecked={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.checked)} className={classes.field} key={column.name} label={column.name}  />}
                            label={column.name}
                            labelPlacement="end"
                        />
            case 'uniqueidentifier':
                    return <TextField fullWidth type="text" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'date':
                    return <TextField InputLabelProps={{shrink: true}} fullWidth type="date" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'datetime':
                    return <TextField InputLabelProps={{shrink: true}} fullWidth type="datetime-local" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
             case 'datetime2':
                    return <TextField InputLabelProps={{shrink: true}}  fullWidth type="datetime-local" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'int':
                    return <TextField fullWidth type="number" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'smallint':
                    return <TextField fullWidth type="number" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'tinyint':
                    return <TextField fullWidth type="number" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'bigint':
                    return <TextField fullWidth type="number" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'varchar':
                    return <TextField fullWidth type="text" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'nvarchar':
                    return <TextField fullWidth type="text" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'text':
                    return <TextField fullWidth type="text" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'ntext':
                    return <TextField fullWidth type="text" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'decimal':
                    return <TextField fullWidth type="number" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'numeric':
                    return <TextField fullWidth type="number" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'image':
                    return <TextField fullWidth type="image" defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            case 'timestamp':
                    return <TextField fullWidth defaultValue={addeditObject[column.name]} onChange={(e) => fieldChanged(column.name, e.target.value.toString())} className={classes.field} key={column.name} label={column.name} />
            default:
                    return <React.Fragment></React.Fragment>
        }
    }

    return <Drawer variant="temporary" className={clsx(classes.drawer, {[classes.drawerOpen]: props.drawerOpen,[classes.drawerClose]: !props.drawerOpen,})} classes={{paper: clsx({[classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen,}),}} anchor='right' open={props.drawerOpen} onClose={() => props.openDrawer("", false, null)}>
                <Button className={classes.closeButton} onClick={() => props.openDrawer("", false, null)}><CloseIcon></CloseIcon></Button>
                <Typography className={classes.headerTitle}>{props.title}</Typography>
                <Divider />
                <div className={classes.drawerBody}>
                    {props.columns.map((column, index) => (
                        GetEditorForDataType(column)
                    ))}
                </div>
                <Button className={classes.saveButton} onClick={() => handleAddEdit(addeditObject, props.title)} fullWidth variant="contained">Save</Button>
            </Drawer>
}

const useStyles = makeStyles((theme) => ({
    spacer80: {
        height: '80px'  
    },
  
    paper: {
          padding: '50px',
          margin: "50px",
          height: '70%'
    },

    crudDrawer: {
        width: 250,
    },

    drawer: {
        width: addEditDrawerWidth ,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        padding: '20px'
    },

    drawerOpen: {
        width: addEditDrawerWidth ,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        padding: '20px'
    },

    drawerClose: {
        width: 0,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden'
    },

    field: {
        display: "block !important"
    },

    saveButton: {
        backgroundColor: "#5CC958",
        color:"white"
    },

    drawerBody: {
        height: "85%",
        overflow: "auto",
        display: "block !important"
    },

    headerTitle: {
        fontSize: '22pt'
    },

    closeButton: {
        justifyContent: "flex-end"
    }
}));